import { render, staticRenderFns } from "./SubmissionSampleAnalytes.vue?vue&type=template&id=42e607bc"
import script from "./SubmissionSampleAnalytes.vue?vue&type=script&lang=js"
export * from "./SubmissionSampleAnalytes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports